import React, { useState, useEffect, useRef } from "react"; // ✅ useRef 추가
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Card,
  Alert,
} from "react-bootstrap";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "../../styles/Login.css";

function Login() {
  const { Server_IP, login, saveUserId, setManagerName, setManagerEmail, setUserType } = useAuth();
  const [companyName, setCompanyName] = useState("");
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");
  const [rememberId, setRememberId] = useState(false);
  const [error, setError] = useState("");

  const passwordInputRef = useRef(null); // ✅ ref 선언

  const manager_ID = process.env.REACT_APP_MANAGER_ID;
  const navigate = useNavigate();

  useEffect(() => {
    setUserType("client");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ✅ 저장된 base64 인코딩 아이디 복호화해서 불러오기 + 포커스 주기
  useEffect(() => {
    const encodedData = localStorage.getItem("rememberedLoginInfo");
    if (encodedData) {
      try {
        const decodedData = JSON.parse(
          decodeURIComponent(escape(atob(encodedData)))
        );
        if (decodedData.id) setId(decodedData.id);
        if (decodedData.companyName) setCompanyName(decodedData.companyName);
        setRememberId(true);

        // ✅ 포커스를 비밀번호 입력창으로 이동
        setTimeout(() => {
          if (passwordInputRef.current) {
            passwordInputRef.current.focus();
          }
        }, 0);
      } catch (err) {
        console.error("로그인 정보 디코딩 실패:", err);
      }
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await axios.post(`${Server_IP}/api/show/oslogin/`, {
        companyName,
        id,
        password,
      });

     const token = response.data.token;
	  
      if (token) {
        login(token);
        saveUserId(id);
        setManagerName("");
        if (companyName === manager_ID) {
          setUserType("manager"); //직원(관리자) 로그인은 회사명에 "관리자"라고 입력
		      setManagerName(response.data.StaffName);
          setManagerEmail(response.data.Email || response.data.email || "");
        }

        if (rememberId) {
          const data = { companyName, id };
          const encodedData = btoa(
            unescape(encodeURIComponent(JSON.stringify(data)))
          );
          localStorage.setItem("rememberedLoginInfo", encodedData);
        } else {
          localStorage.removeItem("rememberedLoginInfo");
        }

        navigate("/");
      } else {
        setError("로그인 실패: 서버에서 토큰이 반환되지 않았습니다.");
      }
    } catch (err) {
      const status = err.response?.status;
      if (!err.response) {
        setError("로그인 서버에 연결할 수 없습니다. 네트워크 및 역방향 프록시 설정을 확인해 주세요.");
      } else if (status === 401 || status === 403) {
        setError("로그인 정보가 일치하지 않습니다.");
      } else if (status >= 500) {
        setError("로그인 서버 오류가 발생했습니다. 백엔드 연결 및 서버 로그를 확인해 주세요.");
      } else {
        setError("로그인 요청에 실패했습니다. 잠시 후 다시 시도해 주세요.");
      }
    }
  };

  return (
    <div className="login-background">
      
      <Container className="login-container">
        <Row className="justify-content-md-center">
          <Col md={6}>
            <Card className="login-card shadow">
              <Card.Body>
                <Card.Title className="text-center mb-4">주문관리시스템 로그인</Card.Title>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form onSubmit={handleLogin}>
                  <Form.Group className="mb-4" controlId="formCompanyName">
                    <Form.Label>회사명</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="회사명을 입력하세요"
                      value={companyName
                        .replace(/주식회사/g, "")
                        .replace(/\(주\)/g, "")
                        .replace(/\(유\)/g, "")
                        .replace(/\s/g, "")}
                      onChange={(e) => setCompanyName(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group className="mb-4" controlId="formBasicId">
                    <Form.Label>아이디</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="거래처코드 입력"
                      value={id}
                      onChange={(e) => setId(e.target.value)}
                      autoComplete="username"
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-4" controlId="formBasicPassword">
                    <Form.Label>비밀번호</Form.Label>
                    <Form.Control
                      ref={passwordInputRef} // ✅ ref 연결
                      type="password"
                      placeholder="비밀번호 입력"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      autoComplete="current-password"
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formRememberId">
                    <Form.Check
                      type="checkbox"
                      label="아이디 저장"
                      checked={rememberId}
                      onChange={(e) => setRememberId(e.target.checked)}
                    />
                  </Form.Group>

                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100 login-button"
                  >
                    로그인
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Login;
